import React from 'react';
import PropTypes from 'prop-types';
import PosterTitle from '../posters/PosterTitle';
import PosterFormatType from '../posters/PosterFormatType';
import Utils from '../../utils/Utils';
import Progress from '../../modules/CardView/components/Progress';

const ContentItem = props => {
  const {
    size,
    onImageError,
    item,
    sizeAlt,
    isPlayAndGo,
    apaAssets,
    isHighlight,
    userType,
    urlPlayer,
    imagesSize = {},
    name,
    title,
    handleClick,
    id,
    isMyContents,
    progressBar,
    enabledChannel,
    type,
  } = props;

  const imgClass = isPlayAndGo ? 'horizontal foxcarr' : 'horizontal';
  const value = title || name;
  let redirectLink = '';
  if (item.id || item.group_id || item.type) {
    redirectLink = Utils.buildRedirect({ content: item, userType, urlPlayer });
  } else {
    redirectLink = { redirectUrl: window.location.pathname };
  }

  if (isPlayAndGo && apaAssets) {
    if (apaAssets[item[size]]) {
      item[size] = apaAssets[item[size]];
    }
    if (sizeAlt && apaAssets[item[sizeAlt]]) {
      item[sizeAlt] = apaAssets[item[sizeAlt]];
    }
  }

  const styleContainer = {
    height: '4px',
    marginTop: '-4px',
  };
  let percentage = 0;
  let hasPercentage = false;
  if (item.id && item.vistime) {
    hasPercentage = true;
    percentage = Number(item.vistime.last.progress);
  }

  item.showTitle = (hasPercentage || isMyContents) && !progressBar;

  return (
    <div>
      <div className="img-wrapper-content">
        <a
          onClick={e => handleClick(e, redirectLink, item, id, value)}
          className="item-img"
        >
          {item[size] && (
            <img
              src={item[size]}
              onError={onImageError}
              className={imgClass}
              height={imagesSize.height}
            />
          )}
          {(sizeAlt ? item[sizeAlt] : item[size]) && (
            <img
              src={sizeAlt ? item[sizeAlt] : item[size]}
              onError={onImageError}
              height={imagesSize.height}
              className={isPlayAndGo ? 'vertical foxcarr' : 'vertical'}
            />
          )}
          {!isPlayAndGo && (
            <span className="play">
              <i className="fa fa-play-circle-o" />
            </span>
          )}

          {hasPercentage && !progressBar && (
            <Progress
              progressPercentage={percentage}
              active
              styleContainer={styleContainer}
            />
          )}
          <PosterFormatType item={item}/>
        </a>
        <div className="title-carousel--div">
          {!isHighlight && <PosterTitle resource={item} type={type} />}
        </div>
      </div>
    </div>
  );
};

ContentItem.propTypes = {
  size: PropTypes.string,
  onImageError: PropTypes.func,
  item: PropTypes.object,
  sizeAlt: PropTypes.string,
  isPlayAndGo: PropTypes.bool,
  apaAssets: PropTypes.object,
  isHighlight: PropTypes.bool,
  userType: PropTypes.string,
  urlPlayer: PropTypes.object,
  imagesSize: PropTypes.object,
  name: PropTypes.string,
  title: PropTypes.string,
  handleClick: PropTypes.func,
  id: PropTypes.string,
  isMyContents: PropTypes.bool,
  progressBar: PropTypes.bool,
  enabledChannel: PropTypes.bool,
};

export default ContentItem;
